import { IBaseModel, BaseModel } from '../base.model';

export interface IUserLogin extends IBaseModel {
  email: string;
  expires?: boolean;
  password: string;
  strategy?: string | 'local' | 'released';
}
export class UserLogin extends BaseModel {
  /**
   *
   */
  email: string;
  expires: boolean;
  password: string;
  strategy: string | 'local' | 'released';
  constructor(opt: IUserLogin) {
    super(opt);
    this.strategy = opt.strategy || 'local';
    this.expires = opt.expires || true;
  }
}


// WEBPACK FOOTER //
// ./src/models/user/user-login.model.ts